<template>
    <div>
      <div  class="row  img">
        <div class="col-8 col-lg-6 m-auto">
         <img src="../assets/img/error.svg" alt="">
        </div>
      </div>
      <div class=" dashboard-alert">
          <div>
            <p class="title"> {{title}}</p>
            <div >
              <p>可能原因：</p>
              <ul>
                <li>账号权限不足</li>
                <li>访问页面被限制</li>
              </ul>
            </div>
          </div>
          <p style="text-align: center">
            <button @click="logout" type="button"  class="btn btn-link">返回首页</button>
          </p>
      </div>
    </div>
</template>

<script>
export default {
  name: "error",
  data() {
    return {
      title: ""
    };
  },
  methods: {
    logout() {
      localStorage.removeItem("account");
      this.$router.push({ path: "/leemmaLogin" });
    }
  }
};
</script>

<style type="scss" scoped>
.dashboard-alert {
}
.img {
  margin: 30px auto;
}
.dashboard-alert img {
  text-align: center;
  display: block;
}
.dashboard-alert > div {
  width: 80%;
  margin: 0 auto;
}
.dashboard-alert > div > div {
  display: flex;
  justify-content: center;
}
.dashboard-alert .title {
  text-align: center;
  border-bottom: 2px solid #fff;
  padding: 10px;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/view/error.vue